import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Acknowledgement } from '../models/acknowledement';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class AcknowledgementService {

  constructor(private httpClient: HttpClient) { }
  
  saveAcknowledgementDetails(payload: Acknowledgement): Observable<any> {
    return this.httpClient.post(ApiConstants.Acknowledgement_Api, payload)
  }
  getAcknowledgementDetails(documentNumber: any,documentVersion:any): Observable<any> {
    return this.httpClient.get(ApiConstants.Acknowledgement_Api+'/'+documentNumber +'/'+documentVersion)
  }

  updateAcknowledgementOnConfirmation(documentNumber: any,documentVersion:any,acknowledgementId: any): Observable<any> {
    return this.httpClient.put(ApiConstants.Acknowledgement_Api+'/'+acknowledgementId,'')
  }
  deleteAcknowledgementDetails(deleteAcknowledgement: any):Observable<any>{
    return this.httpClient.delete(ApiConstants.Acknowledgement_Api, {body:deleteAcknowledgement});
  }
}
